"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COLLECTION_DISPLAY_MODE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _listUnordered = require("@catalytic/catalytic-icons/lib/glyphs/list-unordered.svg");
var _grid = require("@catalytic/catalytic-icons/lib/glyphs/grid.svg");
var _FilterSortItem = _interopRequireDefault(require("./FilterSortItem"));
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var COLLECTION_DISPLAY_MODE = exports.COLLECTION_DISPLAY_MODE = {
  LIST: 'LIST',
  GRID: 'GRID'
};
/*:: export type CollectionDisplayMode = $Values<typeof COLLECTION_DISPLAY_MODE>;*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: (0, _defineProperty2.default)({
      marginBottom: '.5rem'
    }, theme.breakpoints.gte.tablet.portrait, {
      display: 'inline-flex',
      marginBottom: 0,
      marginLeft: 'auto',
      marginRight: 0,
      lineHeight: '2rem' // This line-height should equal the height of the Filter/Sort/Search input element.
    }),
    button: {
      marginLeft: '.75rem',
      '&:first-child': {
        marginLeft: 0
      }
    },
    icon: {
      color: theme.colors.pastelGrey,
      fontSize: '1.125rem'
    },
    selectedIcon: {
      color: theme.colors.scienceBlue
    }
  };
});
/*:: type Props = {
  onChange?: (mode: CollectionDisplayMode) => void,
  defaultValue?: string
};*/
var FilterSortCollectionDisplayMode = function FilterSortCollectionDisplayMode(props /*: Props*/) {
  var _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? COLLECTION_DISPLAY_MODE.LIST : _props$defaultValue,
    onChange = props.onChange;
  var classes = useStyles();
  var setMode = function setMode(sortMode /*: CollectionDisplayMode*/) {
    if (typeof onChange === 'function') {
      onChange(sortMode);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_FilterSortItem.default, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: classes.button,
    onClick: function onClick() {
      return setMode(COLLECTION_DISPLAY_MODE.LIST);
    }
  }, /*#__PURE__*/_react.default.createElement(_listUnordered.ReactComponent, {
    className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.selectedIcon, defaultValue === COLLECTION_DISPLAY_MODE.LIST)),
    "data-testid": "display-mode-list"
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: classes.button,
    onClick: function onClick() {
      return setMode(COLLECTION_DISPLAY_MODE.GRID);
    }
  }, /*#__PURE__*/_react.default.createElement(_grid.ReactComponent, {
    className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.selectedIcon, defaultValue === COLLECTION_DISPLAY_MODE.GRID)),
    "data-testid": "display-mode-grid"
  })));
};
FilterSortCollectionDisplayMode.displayName = 'FilterSortCollectionDisplayMode';
var _default = exports.default = FilterSortCollectionDisplayMode;
//# sourceMappingURL=FilterSortCollectionDisplayMode.js.map